import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_table = _resolveComponent("app-table")!
  const _component_app_card = _resolveComponent("app-card")!

  return (_openBlock(), _createBlock(_component_app_card, {
    label: `${_ctx.transactionColumnByType.title} Transactions (AccountID: ${_ctx.accountId})`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_app_table, {
        rows: _ctx.list,
        columns: _ctx.columns,
        offset: _ctx.query.offset,
        limit: _ctx.query.limit,
        total: _ctx.total,
        onRefreshData: _ctx.fetchList
      }, null, 8, ["rows", "columns", "offset", "limit", "total", "onRefreshData"])
    ]),
    _: 1
  }, 8, ["label"]))
}